import React from 'react';
import style from './app-box.module.scss';
import type { AppBoxSkin } from './app-box.types';

import { NarrowAppBoxSkeleton } from './app-box-layouts/narrow-app-box';
import { RegularAppBoxSkeleton } from './app-box-layouts/regular-app-box';
import { WideAppBoxSkeleton } from './app-box-layouts/wide-app-box';
import { RegularSlimAppBoxSkeleton } from './regular-slim-app-box-skeleton';
import { NarrowSlimAppBoxSkeleton } from './narrow-slim-app-box-skeleton';

export interface AppBoxSkeletonProps {
  skin?: AppBoxSkin;
}

export function AppBoxSkeleton({ skin = 'default' }: AppBoxSkeletonProps) {
  return (
    <div
      className={
        skin === 'slim'
          ? `${style.appBoxContainer} ${style.slimAppBoxSkeleton} ${style.skinSlim}`
          : `${style.appBoxContainer} ${style.appBoxSkeleton} ${
              skin === 'default' ? style.skinDefault : style.skinSlim
            }`
      }
    >
      {skin === 'slim' ? (
        <>
          <NarrowSlimAppBoxSkeleton className={style.narrowSlimLayout} />
          <RegularSlimAppBoxSkeleton className={style.regularSlimLayout} />
        </>
      ) : (
        <>
          <NarrowAppBoxSkeleton className={style.narrowLayout} />
          <RegularAppBoxSkeleton className={style.regularLayout} />
          <WideAppBoxSkeleton className={style.wideLayout} />
        </>
      )}
    </div>
  );
}
